module.exports = __webpack_public_path__ + "7f928b3057508a4a35bb5ec5578f82d6.svg";